import { render, staticRenderFns } from "./ActorDetailOPGeneralComponent.vue?vue&type=template&id=52773bf3&"
import script from "./ActorDetailOPGeneralComponent.vue?vue&type=script&lang=js&"
export * from "./ActorDetailOPGeneralComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports